import { Route, Routes } from "react-router-dom"
import Main from "../pages/main"
import { GeneralConfigProvider } from "../context"
import { Form } from "../pages/form"
import { Edit } from "../pages/edit"

const GeneralConfigRoutes = () => {
  return (
    <GeneralConfigProvider>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/form" element={<Form />} />
        <Route path="/form/:id" element={<Edit />} />
      </Routes>
    </GeneralConfigProvider>
  )
}

export default GeneralConfigRoutes
